import React, { useState, useEffect, useCallback } from "react";
import './rdt.scss';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import 'moment/locale/ru';
import 'moment/locale/en-in';
import 'moment/locale/es';
import momentTZ from "moment-timezone";
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

const matchLangToLocale = {
    ru: `ru`,
    en: `en-gb`,
    la: `es`
};

const DateTime = ({ value: valueFromProps, change, field, required, data, serverTimeZone, userTimeZone }) => {
    const [value, setValue] = useState(valueFromProps.length > 0 ? new Date(valueFromProps) : ``);
    const [ needToInvalidMarking, setNeedToInvalidMarking ] = useState(false);
    const { i18n } = useTranslation();
    const locale = matchLangToLocale[i18n.language];

    useEffect(() => {
        setValue(valueFromProps.length > 0 ? new Date(valueFromProps) : ``);
    }, [valueFromProps]);

    const onChangeHandler = (val) => {
        const relatedDT = val._isAMomentObject ? new Date(val.format(`YYYY-MM-DD[T]HH:mm:ssZ`)) : val;
        console.log('change handler', relatedDT);
        setValue(relatedDT);
    };

    const onCloseHandler = (val) => {
        const valueIsEmpty = typeof val === 'string' && val.length === 0;
        const valueIsValid = val._isAMomentObject || !required && valueIsEmpty;
        if (!valueIsValid) {
            setNeedToInvalidMarking(true);
        } else if (needToInvalidMarking) {
            setNeedToInvalidMarking(false);
        }
        const resultDT = val._isAMomentObject ? momentTZ(value).tz(serverTimeZone).format(`YYYY-MM-DD[T]HH:mm:ssZ`) : value;
        console.log('datetime: on close', field, resultDT, valueIsValid);
        change(resultDT, field, valueIsValid);
    };

    console.log('datetime data', serverTimeZone, userTimeZone);

    return (
        <div className="rdt-container">
            <Datetime
                value={value}
                onChange={onChangeHandler}
                onClose={onCloseHandler}
                locale={locale}
                className={classnames({ '_invalid': needToInvalidMarking })}
                closeOnSelect
                displayTimeZone={userTimeZone}
                // input={false}
            />      
        </div>
    )
};

export default DateTime;